<template>
  <div>
    <div class="search-wrapper">
      <span>地区：</span>
      <Select v-model="searchValue.address" style="width: 90px;margin-right:20px;">
        <Option v-for="company in childCompanies" :key="company.name" :value="company.name">{{company.name}}</Option>
      </Select>
      <span>项目名称：</span>
      <Input style="width:180px;margin-right:20px;" type="text" v-model="searchValue.project_name"></Input>
      <span>采购人：</span>
      <Input style="width:120px;margin-right:20px;" type="text" v-model="searchValue.buyer"></Input>
      <span>项目性质：</span>
      <Select v-model="searchValue.property" style="width: 100px;margin-right:20px">
        <Option  v-for="property in propertyArr" :key="property.id" :value="property.itemName">{{property.itemName | projectProperty}}</Option>
      </Select>
      <span>行业系统：</span>
      <Select v-model="searchValue.industry" style="width: 140px;margin-right:20px">
        <Option
          v-for="system in systemArr"
          :key="system.id"
          :value="system.itemName"
        >{{system.itemName}}</Option>
      </Select>
      <span>项目状态：</span>
      <Select v-model="searchValue.project_status" style="width: 160px;margin-right:20px">
        <Option v-for="item in projectStatus" :key="item.id" :value="item.value">{{item.name}}</Option>
      </Select>
      <br>
      <span>立项时间：</span>
      <DatePicker type="date" style="width: 150px" v-model="startTime"></DatePicker>
      <span>至</span>
      <DatePicker type="date" style="width: 150px" v-model="endTime"></DatePicker>
      <span style="margin-left:20px;">是否参与：</span>
      <Select v-model="searchValue.participation" style="width: 100px;margin-right:20px">
        <Option v-for="item in participation" :key="item.id" :value="item.name">{{item.name}}</Option>
      </Select>
      <span>文件审核状态：</span>
      <Select v-model="searchValue.reviewStatus" style="width: 100px;margin-right:20px">
        <Option v-for="item in fileStatus" :key="item.id" :value="item.value">{{item.name}}</Option>
      </Select>
      <span>操作人员：</span>
      <Input style="width:120px" type="text" v-model="searchValue.reviewPerson"></Input>
      <Button type="primary" @click="searchProject" style="margin:5px 10px;">查询</Button>
      <Button type="primary" @click="addProject" icon="android-add" style="margin:5px 0;">添加</Button>
      <Button type="success" @click="viewBidData" style="margin:5px 10px;">投标管理数据一览</Button>
    </div>
    <Modal title="投标管理数据一览" v-model="bidDataVisible" width="98%" height="95%" class-name="bidding-modal">
      <iframe :src="fineUrl" style="width:100%;height:100%;border:0;"></iframe>
      <div slot="footer"></div>
    </Modal>
		<!-- 基本信息 -->
    <baseInfomation
			:showModal="baseInfomation" 
			:title="title" 
			:formData="formData" 
      @init="init"
			@visibleChange="visibleChange" 
			@updateData="getProjectData(1,{})"
      ref="baseInfomation"
    ></baseInfomation>
		<!-- 文件汇总 -->
		<fileCollect 
			:showModal="fileCollect" 
			:formData="formData" 
			@visibleChange="visibleChange"
			ref="fileUpload"
    ></fileCollect>
    <!-- 发起流程 -->
    <!-- 流程审批方向选择 -->
    <flowBranch
      :visible="branchVisible"
      :branchList="flowBranch"
      @visibleChange="visibleChange"
      @branchChoose="branchChoose"
      :branchType="branchType"
      :reason="reason"
      ref="flowBranch"
    ></flowBranch>
    <!-- 流程人员选择 -->
    <Modal
      v-model="peopleSelectVisible"
      class="flow-modal"
      width="700px"
      title="流程人员选择"
    >
      <flowNext
        :child-msg="flowPeople"
        @toparentevent="handlePeopleSelect"
      ></flowNext>
      <div slot="footer">
        <Button @click="peopleSelectVisible=false">取消</Button>
        <Button
          @click="startFlow"
          type="primary"
        >确定</Button>
      </div>
    </Modal>
    <!-- 确认弹窗 -->
    <confirmModal 
      :showModal="confirmModal"
      :showTips="showTips"
      :tipType="tipType"
      @visibleChange="confirmChange"
      ref="paticipation"
      :formData="formData"
      @result="biddingResult"
      @appendix="getBranch"
      @auditMind="rejectFlow">
    </confirmModal>
    <!-- 流程详情 -->
    <Modal v-model="flowHistoryVisible" title="流程详情" width="800">
      <flowHistory :flowDetailHistory="flowDetailHistory"></flowHistory>
      <div slot="footer"></div>
    </Modal>
    <Table :columns="columns" :data="projectData" :loading="tableLoading" style="min-width:1500px;"></Table>
    <Page :total="pageTotal" :current="currentPage" show-elevator show-total style="margin-top:5px;" @on-change="pageChange"></Page>
  </div>
</template>

<script>
import ajax from "@/lib/ajax"
import requestUrls from "@/lib/requestUrls"
import axios from "axios"
import { formatDate, guid } from "@/lib/tool"
import { fileUtil } from "@/lib/abpfile"
import sendMessage from "@/lib/message"
import { setTimeout } from "timers"
import { Tooltip, Icon } from "iview"
import baseInfomation from "./baseInfomation"
import fileCollect from "./fileCollect"
import confirmModal from "./confirmModal"
import FlowBranch from '@/components/flow/flowBranch'
import FlowNext from "@/components/flow/flowNext"
import FlowHistory from '@/components/flow/flowHistory'
import { getActivityUsers, startWorkflow, deliverFlow, getFlowHistory, endFlow, getRejectActivityUsers, rejectFlow } from '@/lib/flow'

export default {
  components: {
    Tooltip,
    Icon,
		baseInfomation,
    fileCollect,
    confirmModal,
    FlowBranch,
    FlowNext,
    FlowHistory
  },
  data() {
    return {
      tableLoading: false, //列表刷新loading
      propertyArr: [],
      systemArr: [],
      participation: [
        {
          id: 1,
          name: "是"
        },
        {
          id: 2,
          name: "否"
        },
        {
          id: 3,
          name: "未审核"
        },
        {
          id: 0,
          name: "全部"
        }
      ],
      fileStatus: [
        {
          id: 1,
          value: "1",
          name: "已通过"
        },
        {
          id: 2,
          value: "0",
          name: "不通过"
        },
        {
          id: 3,
          value: "未审核",
          name: "未审核"
        },
        {
          id: 0,
          value: "全部",
          name: "全部"
        }
      ],
      projectStatus: [
        {
          id: 1,
          value: "不参与",
          name: "不参与"
        },
        {
          id: 2,
          value: "未发起",
          name: "未发起"
        },
        {
          id: 3,
          value: "立项审核退回",
          name: "立项审核退回"
        },
        {
          id: 4,
          value: "立项审核中",
          name: "立项审核中"
        },
        {
          id: 5,
          value: "等待上传报名资料",
          name: "等待上传报名资料"
        },
        {
          id: 6,
          value: "报名资料待盖章",
          name: "报名资料待盖章"
        },
        {
          id: 7,
          value: "等待上传投标文件",
          name: "等待上传投标文件"
        },
        {
          id: 8,
          value: "文件审核中",
          name: "文件审核中"
        },
        {
          id: 9,
          value: "等待上传投标文件终稿",
          name: "等待上传投标文件终稿"
        },
        {
          id: 10,
          value: "投标文件待盖章",
          name: "投标文件待盖章"
        },
        {
          id: 11,
          value: "待结项",
          name: "待结项"
        },
        {
          id: 12,
          value: "投标成功",
          name: "投标成功"
        },
        {
          id: 13,
          value: "投标失败",
          name: "投标失败"
        },
        {
          id: 0,
          value: "全部",
          name: "全部"
        }
      ],
      childCompanies: [],
      searchValue: {
        project_name: "", // 项目名称
        address: "", // 分公司
        buyer: "", // 采购人
        property: "", // 项目性质
        industry: "", // 行业系统
        participation: "", // 是否参与
        reviewStatus: "", // 文件审核状态
        reviewPerson: "", // 审核人员
        project_status: ""  //项目状态
      },
      columns: [
        {
          title: "地区",
          key: "address",
          align: "center",
          width: 90
        },
        {
          title: "项目名称",
          key: "project_name",
          render: (h,params) => {
            return [
              h('Icon', {
                props: {
                  type: 'alert-circled',
                  color: '#ff9900',
                  size: '14'
                },
                style: {
                  marginRight: '5px',
                  display: this.isErgent ? '' : 'none'
                }
              }),
              h('span', params.row.project_name)
            ]
          }
        },
        {
          title: "项目负责人",
          key: "principal",
          align: "center",
          width: 104
        },
        {
          title: "招标形式",
          key: "modality",
          align: "center",
          width: 100
        },
        {
          title: "采购人名称",
          key: "buyer",
          width: 160
        },
        {
          title: "行业系统",
          key: "industry",
          align: "center",
          width: 120
        },
        {
          title: "项目状态",
          key: "project_status",
          align: "center",
          width: 130
        },
        {
          title: "保证金金额",
          key: "bond",
          align: "center",
          width: 100
        },
        {
          title: "合同期限",
          key: "contract_date2",
          width: 100,
          render: (h,params) => {
            if (params.row.contract_date2) {
              return h('div', params.row.contract_date2.split('T')[0])
            }
          }
        },
        {
          title: "操作人员",
          width: 135,
          key: "reviewPerson",
          align: "center",
          render: (h, params) => {
            return h("span", params.row.reviewPerson);
          }
        },
        {
          title: "操作",
          key: "Actions",
          width: 280,
          render: (h, params) => {
            return h("div", [
							h('div',[
								// 基本信息
								h(
									"Button",
									{
										props: {
											type: "primary",
											size: "small"
										},
										style: {
                      margin: "4px"
										},
										on: {
											click: () => {
												this.editMessage(params.row);
											}
										}
									},
									"基本信息"
								),
								h(
									"Button",
									{
										props: {
											type: "primary",
											size: "small"
										},
										style: {
                      margin: "4px"
										},
										on: {
											click: () => {
												this.file(params.row);
											}
										}
									},
									"文件汇总"
								),
								h(
									"Button",
									{
										props: {
											type: "warning",
											size: "small"
										},
										style: {
                      margin: "4px",
                      display: this.isErgent ? '' : 'none'
										},
										on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: '到期认领',
                          content: '<p>请选择认领方式，已有认领项目则点击“ 已有项目认领 ”，需要新建认领项目则点击“ 新建认领 ”</p>',
                          okText: '新建认领',
                          cancelText: '已有项目认领',
                          closable: true,
                          onOk: () => {
                            this.followProject(params.row)
                          },
                          onCancel: () => {
                            this.formData = params.row
                            this.formData.isClaim = true
                            this.dataUpdate(this.formData).then(() => {
                              this.$Message.success('认领成功！')
                              this.getProjectData(1,{})
                            })
                          }
                        })
											}
										}
									},
									"到期认领"
								),
							]),
							h('div',{
                style: {
                  display: !this.isErgent ? '' : 'none'
                }
                },[
                h(
                  "Button",
                  {
                    props: {
                      type: "success",
                      size: "small",
                      disabled: !(this.user.name === params.row.principal && params.row.project_status === '未发起')
                    },
                    style: {
                      margin: "4px"
                    },
                    on: {
                      click: () => {
                        this.tipType = '招标公告'
                        this.showTips = true
                        this.formData = params.row
                      }
                    }
                  },
                  "发起"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "success",
                      size: "small",
                      disabled: this.flowDisabled(params)
                    },
                    style: {
                      margin: "4px"
                    },
                    on: {
                      click: () => {
                        this.branchType = 'next'
                        this.circulation(params.row)
                      }
                    }
                  },
                  "流转"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small",
                      disabled: this.rejectDisabled(params)
                    },
                    style: {
                      margin: "4px"
                    },
                    on: {
                      click: () => {
                        this.formData = params.row
                        this.branchType = 'reject'
                        if (params.row.project_status === '文件审核中') {
                          this.tipType = '审核意见'
                          this.showTips = true
                          return
                        }
                        this.rejectFlow()
                      }
                    }
                  },
                  "退回"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    style: {
                      margin: "4px"
                    },
                    on: {
                      click: async() => {
                        if (params.row.project_status === '未发起' || !params.row.project_status) {
                          this.$Message.info('尚未发起流程')
                          return
                        }
                        if (!params.row.workFlowId) {
                          this.$Modal.warning({
                              title: '流程详情',
                              content: '旧项目流程未发起，无流程详情',
                              okText: '确定',
                              onOk: () => {}
                          });
                          return
                        }
                        let rep = await getFlowHistory(this.user.phoneNumber, params.row.workFlowId)
                        this.flowDetailHistory = rep
                        this.flowHistoryVisible = true
                      }
                    }
                  },
                  "流程详情"
                )
							]),
            ]);
          }
        }
      ],
      currentPage: 1,
      pageTotal: 0,
      projectData: [],
      startTime: "",
      endTime: "",
			baseInfomation: false,
			formData: {},
			title: '添加项目',
      fileCollect: false,
      confirmModal: false,
      branchVisible: false,
      branchType: 'next',
      flowBranch: [],
      peopleSelectVisible: false,
      flowPeople: {},
      selectedPeople: '',
      operateFlowHistory: [],
      operateFlowTaskId: '',
      finalStatus: '',
      flowDetailHistory: [],
      flowHistoryVisible: false,
      showTips: false,
      tipType: '',
      reason: '',
      bidDataVisible: false,
      fineUrl: '',
      halfYear: ''
    };
  },
  watch: {
    $route(to,from){
      // 获取列表数据
      this.getProjectData(1, {})
      // 重置搜索
      Object.keys(this.searchValue).forEach(key => {
        this.searchValue[key] = ''
      })
    }
  },
  async created() {
    // 半年内 时间节点
    let date = new Date()
    date.setMonth( date.getMonth() + 6 )
    this.halfYear = formatDate(date).slice(0,10)
    this.getProjectData(1, {})
  },
  filters: {
    projectProperty(val) {
      if (val !== "全部") {
        return val + "类";
      } else {
        return val;
      }
    }
  },
  computed: {
    auditor() {
      return this.$refs.baseInfomation.getAuditor()
    },
    user() {
      return this.$store.state.session.user
    },
    isEditor() {
      return this.formData.data_sources === '军工事业部'
    },
    isErgent() {
      return this.$route.name === 'biddingManagement2'
    }
  },
  methods: {
    viewBidData() {
      this.fineUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B6295%5D%5B6807%5D%5B7ba1%5D%5B7406%5D%2FBiddingManage.cpt`
      this.bidDataVisible = true
    },
    init(childCompanies, propertyArr, systemArr) {
      this.childCompanies = childCompanies
      this.propertyArr = propertyArr
      this.systemArr = systemArr
    },
    async getProjectData(page = 1, queryObj = {}) {
      this.currentPage = page
      let querySear = "";
      let searName = queryObj.project_name ? ` and project_name.Contains("${queryObj.project_name}")` : "";
      let searAddress = queryObj.address && queryObj.address !== "全部" ? ` and address.contains("${queryObj.address}")` : "";
      let searBuyer = queryObj.buyer ? ` and buyer.Contains("${queryObj.buyer}")` : "";
      let searProperty = queryObj.property && queryObj.property !== "全部" ? ` and property.Contains("${queryObj.property}")` : "";
      let searIndustry = queryObj.industry && queryObj.industry !== "全部" ? ` and industry.Contains("${queryObj.industry}")` : "";
      let searParticipation = queryObj.participation && queryObj.participation !== "全部" ? ` and participation.Contains("${queryObj.participation}")` : "";
      let searAuditor = queryObj.reviewPerson ? ` and reviewPerson.Contains("${queryObj.reviewPerson}")` : "";
      let searProStatus = queryObj.project_status && queryObj.project_status !== "全部" ? ` and project_status.Contains("${queryObj.project_status}")` : "";
      if (queryObj.participation === "未审核") {
        searParticipation = ` and participation == null`;
      }
      let searStatus = queryObj.reviewStatus && queryObj.reviewStatus !== "全部" ? ` and reviewStatus.Contains("${queryObj.reviewStatus}")` : "";
      if (queryObj.reviewStatus === "未审核") {
        searStatus = ` and reviewStatus == null`;
      }
      let searTime = this.startTime !== "" ? ` and bid_date >= "${formatDate(this.startTime)}" and bid_date <= "${formatDate(this.endTime)}"` : "";
      querySear = searName + searAddress + searBuyer + searProperty + searIndustry + searParticipation + searStatus + searTime + searAuditor + searProStatus + ' and isMIReview == true';
      querySear = querySear.slice(5);
      this.tableLoading = true;
      let ergentQuery = querySear ? `contract_date2 <= "${this.halfYear}" and ${querySear}` : `contract_date2 <= "${this.halfYear}" and isMIReview == true`
      let rep = await ajax.get(
        requestUrls.ClBidManage.GetPaged + "?sorting=id desc",
        {
          params: {
            filter: this.isErgent ? ergentQuery : querySear,
            maxResultCount: 10,
            skipCount: (page - 1) * 10
          }
        }
      );
      if (rep.data.success) {
        this.tableLoading = false
        this.projectData = rep.data.result.items
        this.pageTotal = rep.data.result.totalCount
      }
    },
    // 查询
    searchProject() {
      this.currentPage = 1
      this.getProjectData(1, this.searchValue)
    },
    pageChange(page) {
      this.getProjectData(page, this.searchValue)
		},
		visibleChange(status) {
      if (!status) {
        this.reason = ''
        this.branchVisible = status
				this.baseInfomation = status
        this.fileCollect = status
			}
    },
    confirmChange(status) {
      if(!status) {
        this.showTips=status
        this.confirmModal=status
      }
    },
    // 更新列表数据
    async dataUpdate(params) {
      let req = JSON.parse(JSON.stringify(params))
      if (req.property) {
        req.property = req.property.join("+")
      }
      let res = await ajax.post(requestUrls.ClBidManage.CreateOrUpdate, {
        clBidManage: req
      })
      return res
    },
    // 添加项目
    addProject() {
			this.title = '添加项目'
			this.formData = {
        principal: this.user.name
      }
      this.baseInfomation = true
		},
    // 基本信息
    async editMessage(e) {
      this.$refs.baseInfomation.reset()
			this.title = '基本信息'
			this.formData = e
      this.baseInfomation = true
		},
		// 文件汇总
		file(e) {
      this.formData = e
			this.fileCollect = true
			this.$refs.fileUpload.getHistory(e.id)
    },
    // 项目到期认领
    followProject(e) {
      this.title = '到期认领'
      this.formData = {
        sourceId: e.id,
        data_sources: e.data_sources,
        address: e.address,
        project_name: e.project_name,
        principal: this.user.name,
        project_num: e.project_num,
        property: e.property,
        buyer: e.buyer,
        contact: e.contact,
        buyer_contact: e.buyer_contact,
        agency: e.agency,
        industry: e.industry
      }
      this.baseInfomation = true
    },
    branchChoose(val) {
      if (this.branchType === 'next') {
        // 下一流程人员选择
        this.peopleSelectVisible = true
      }
      this.flowPeople = val
      if (this.branchType === 'reject') {
        if (this.$refs.flowBranch.opinion === '') {
          this.$Message.info('请填写退回原因')
          return
        }
        this.rejectFlowConfirm()
        return
      }
    },
    // 发起
    getBranch() {
      this.approvalFlowNext(this.formData.address, `${this.isEditor}`, `${this.formData.isEnroll}`, 'true' )
    },
    handlePeopleSelect(selectedPeople) {
      this.selectedPeople = selectedPeople
    },
    // 流转
    async circulation(e) {
      this.formData = e
      let files = await this.$refs.fileUpload.getHistory(e.id) // 项目文件
      switch (e.project_status) {
        case '立项审核退回':
          this.approvalFlowNext(e.address, `${this.isEditor}`, `${e.isEnroll}`)
          break
        case '立项审核中':
          this.$refs.paticipation.reset()
          this.confirmModal = true
          break
        case '等待上传报名资料':
          let type7 = files.filter( item => item.fileType === '7' )  // 报名资料
          if (type7.length > 0) {
            this.approvalFlowNext(e.address, 'true', `${e.isEnroll}`)
          } else {
            this.$Message.info('请前往“ 文件汇总 ”上传报名资料')
          }
          break
        case '报名资料待盖章':
          this.approvalFlowNext(e.address, 'true', `${e.isEnroll}`)
          break
        case '等待上传投标文件':
          // 是否参与投标
          if (this.formData.participation == '') {
            this.$Message.info('请前往‘ 基本信息 ’确认是否参与投标！')
            return
          } else if (this.formData.participation === '是') {
            // 填写保证金信息
            if (!e.bond || !e.marginAccount || !e.marginAccountName || !e.offer_demand ) {
              this.$Message.info('请前往‘ 基本信息 ’完成信息填写')
              return
            }
            let type1 = files.filter( item => item.fileType === '1' )  // 招标文件
            let type2 = files.filter( item => item.fileType === '2' )  // 投标文件初稿
            if (type1.length > 0 && type2.length > 0) {
              this.approvalFlowNext(e.address, 'true', `${e.isEnroll}`)
            } else {
              this.$Message.info('请前往“ 文件汇总 ”上传招标文件和投标文件初稿')
            }
          } else if (this.formData.participation === '否') {
            // 填写备注 上传招标文件 结束流程
            let type1 = files.filter( item => item.fileType === '1' )  // 招标文件
            if (type1.length > 0) {
              this.approvalFlowNext(e.address, 'true', `${e.isEnroll}`, 'false')
            } else {
              this.$Message.info('请前往“ 文件汇总 ”上传招标文件')
            }
          }
          break
        case '文件审核中':
          this.approvalFlowNext(e.address, 'true', `${e.isEnroll}`)
          break
        case '等待上传投标文件终稿':
          let type3 = files.filter( item => item.fileType === '3' )  // 投标文件终稿
          let type6 = files.filter( item => item.fileType === '6' )  // 签字/盖章文件
          if (type3.length > 0 && type6.length > 0) {
            this.approvalFlowNext(e.address, 'true', `${e.isEnroll}`)
          } else {
            this.$Message.info('请前往“ 文件汇总 ”上传投标文件终稿和签字/盖章要求')
          }
          break
        case '投标文件待盖章':
          this.approvalFlowNext(e.address, 'true', `${e.isEnroll}`)
          break
        case '待结项':
          this.confirmModal = true
          break
      }
    },
    flowDisabled(params) {
      switch (params.row.project_status) {
        case '立项审核退回':
        case '等待上传报名资料':
        case '等待上传投标文件':
        case '等待上传投标文件终稿':
        case '待结项':
          return this.user.name === params.row.principal ? false : true
          break
        case '立项审核中':
        case '文件审核中':
          return params.row.reviewPerson !== this.user.name
          break
        case '报名资料待盖章':
        case '投标文件待盖章':
          return params.row.reviewPerson !== this.user.name
          break
        default:
          return true
      }
    },
    rejectDisabled(params) {
      switch (params.row.project_status) {
        case '立项审核中':
        case '文件审核中':
          return !(params.row.reviewPerson === this.user.name && (params.row.project_status === '立项审核中' || params.row.project_status === '文件审核中'))
        break
        case '报名资料待盖章':
        case '投标文件待盖章':
          return params.row.reviewPerson !== this.user.name
          break
        default:
          return true
      }
    },
    // 获取流程人员
    async approvalFlowNext(address,join,enroll,bidJoin='true') {
      this.operateFlowTaskId = ''
      this.$Spin.show()
      let processVariablesJson = JSON.stringify([{ key: 'area', value: address },{ key: 'join', value: join }, { key: 'enroll', value: enroll}, { key: 'bidJoin', value: bidJoin}])
      try {
        if (this.formData.project_status !== '未发起') {
          // 获取taskId,taskId通过读取历史最后一个流程信息获得
          this.operateFlowHistory = []
          let hisRep = await getFlowHistory(this.user.phoneNumber, this.formData.workFlowId)
          this.operateFlowHistory = hisRep
          this.operateFlowTaskId = hisRep[hisRep.length-1].TaskId
        }
        let rep = await getActivityUsers({ appId: 'JT', userPhone: this.user.phoneNumber, processVariablesJson: processVariablesJson, taskId: this.operateFlowTaskId })
        this.$Spin.hide()
        this.branchType = 'next'
        this.flowBranch = rep
        if(rep.length > 1) {
          this.$Message.error('该状态下的项目不可退回')
          return
        }
        this.branchVisible = true
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('流程人员获取失败')
      }
    },
    // 确定流转
    async startFlow() {
      if (this.selectedPeople === '' && this.flowPeople.NextActivityName !== '结束') {
        this.$Message.error('请先选择流程人员')
        return
      }
      // 发起流程
      if (this.formData.project_status === '未发起') {
        const wiid = guid()
        let thisUser = {
          appId: 'JT',
          userPhone: this.user.phoneNumber,
          wiid: wiid, // 生成一个guid
          opinion: this.$refs.flowBranch.opinion
        }
        let nextUser = {
          nextActivityCode: this.flowPeople.NextActivityCode,
          userId: this.selectedPeople.userId
        }
        this.$Spin.show()
        try {
          let rep = await startWorkflow(thisUser, nextUser)
          this.$Spin.hide()
          this.branchVisible = false
          this.$Message.success('流程发起成功')
          this.peopleSelectVisible = false
          this.formData.workFlowId = wiid
          this.formData.reviewPerson = this.selectedPeople.userName  // 操作人员
          // let isSent = this.formData.data_sources === '战略客户中心'
          if (this.isEditor) {  // 是否战略客户中心
            this.formData.participation = "是"
            this.formData.project_status = this.formData.isEnroll ? "等待上传报名资料" : '等待上传投标文件'
          } else {
            this.formData.participation = ""
            this.formData.project_status = this.formData.isEnroll ? "立项审核中" : '等待上传投标文件'
          }
          // 确定报名则发送信息通知
          if (this.formData.isEnroll) {
            let principal = [this.$refs.baseInfomation.getAuditor(),'李柱']
            principal.forEach(el => {
              let messageParams = {
                appId: '1005',
                uniqueId: el, // 用户名
                contentJson: {
                title: '投标管理',
                subTitle:  this.isEditor ? '项目立项' : '添加项目',
                description: this.isEditor ? `项目：${this.formData.project_name} 已立项,报名资料准备中` : `项目：${this.formData.project_name} 已添加成功,请确认是否参与`,
                url: 'http://qy.chinapsp.cn:8884?qyLogin#/customerManage/tbgl2'
                }
              }
              sendMessage('wechat', messageParams)
            })
          }
          this.dataUpdate(this.formData)
        } catch (err) {
          console.error(err)
          this.$Spin.hide()
          this.$Message.error('发起流程失败')
        }
        return
      } 
      if (this.flowPeople.NextActivityName !== '结束') {
        // 流程转交
        this.$Spin.show()
        try {
          let processVariablesJson = JSON.stringify([{ key: 'district', value: 'true' }]) // 附带参数
          let rep = await deliverFlow(this.user.phoneNumber, { taskId: this.operateFlowTaskId, nextActivityCode: this.flowPeople.NextActivityCode, userId: this.selectedPeople.userId, processVariablesJson: processVariablesJson, opinion: this.$refs.flowBranch.opinion })
          let messageParams = {}
          let next = this.flowBranch[0].NextActivityName
          switch (true) {
            case next.indexOf('参与确认') != -1:
              this.formData.project_status = '立项审核中'
              break
            case next.indexOf('报名文件') != -1:
              this.formData.participationReason = ''
              this.formData.participation = "是"
              this.formData.project_status = '等待上传报名资料'
              this.$refs.paticipation.continueFlow()
              break
            case next.indexOf('报名资料') != -1:
              this.formData.project_status = '报名资料待盖章'
              break
            case next.indexOf('投标文件') != -1:
              this.formData.project_status = '等待上传投标文件'
              messageParams = {
                appId: '1005',
                uniqueId: this.formData.principal, // 用户名
                contentJson: {
                  title: '投标管理',
                  subTitle: '资料审核',
                  description: `项目：${this.formData.project_name} 报名资料盖章完成，请上传投标文件`,
                  url: 'http://qy.chinapsp.cn:8884?qyLogin#/customerManage/tbgl2'
                }
              }
              sendMessage('wechat', messageParams)
              break
            case next.indexOf('文件审核') != -1:
              this.formData.project_status = '文件审核中'
              // 信息通知
              let principal = [this.selectedPeople.userName, "李柱"]
              principal.forEach(el => {
                messageParams = {
                  appId: "1005",
                  uniqueId: el, // 用户名
                  contentJson: {
                    title: "投标管理",
                    subTitle: "文件审核",
                    description: `项目：${this.formData.project_name} 投标文件已上传，请审核`,
                    url: "http://qy.chinapsp.cn:8884?qyLogin#/customerManage/tbgl2"
                  }
                };
                sendMessage("wechat", messageParams)
              })
              break
            case next.indexOf('终稿') != -1:
              this.formData.project_status = '等待上传投标文件终稿'
              // TODO:信息通知
              messageParams = {
                appId: '1005',
                uniqueId: this.formData.principal, // 用户名
                contentJson: {
                  title: '投标管理',
                  subTitle: '文件审核',
                  description: `项目：${this.formData.project_name} 投标文件审核完成`,
                  url: 'http://qy.chinapsp.cn:8884?qyLogin#/customerManage/tbgl2'
                }
              }
              sendMessage('wechat', messageParams)
              break
            case next.indexOf('盖章邮寄') != -1:
              this.formData.project_status = '投标文件待盖章'
              messageParams = {
                appId: '1005',
                uniqueId: this.formData.reviewPerson, // 用户名
                contentJson: {
                  title: '投标管理',
                  subTitle: '文件审核',
                  description: `项目：${this.formData.project_name} 终稿文件已完成，请检查后盖章`,
                  url: 'http://qy.chinapsp.cn:8884?qyLogin#/customerManage/tbgl2'
                }
              }
              sendMessage('wechat', messageParams)
              break
            case next.indexOf('结项') != -1:
              this.formData.project_status = '待结项'
              break
          }
          this.formData.reviewPerson = this.selectedPeople.userName  // 操作人员
          this.dataUpdate(this.formData).then(() => {
            this.getProjectData(1,{})
            this.branchVisible = false
            this.$Message.success('流程流转到下一步')
            this.peopleSelectVisible = false
            this.$Spin.hide()
            this.selectedPeople = {}
          })
        } catch (err) {
          console.error(err)
          this.$Spin.hide()
          this.$Message.error('流程转交失败')
        }
      } else {
        // 结束流程
        this.$Spin.show()
        try {
          let rep = await endFlow(this.user.phoneNumber, { taskId: this.operateFlowTaskId, nextActivityCode: this.flowPeople.NextActivityCode, opinion: this.$refs.flowBranch.opinion })
          this.formData.project_status = this.finalStatus
          if (this.finalStatus === '不参与') {
            this.formData.participation = '否'
            this.formData.participationReason = this.reason
            this.formData.project_status = '不参与'
            this.$refs.paticipation.cancelFlow()
          }
          this.formData.reviewPerson = '完成'
          this.dataUpdate(this.formData).then(() => {
            this.branchVisible = false
            this.$Message.success('流程结束成功')
            this.peopleSelectVisible = false
            this.getProjectData(1,{})
            this.$Spin.hide()
            this.selectedPeople = {}
          })
        } catch (err) {
          console.error(err)
          this.$Spin.hide()
          this.$Message.error('流程结束失败')
        }
      }
    },
    // 获取投标结果
    biddingResult(val, reason) {
      this.finalStatus = val
      if (val === '不参与') {
        this.reason = reason
        this.approvalFlowNext(this.formData.address, 'false', `${this.formData.isEnroll}`)
      } else {
        this.approvalFlowNext(this.formData.address, 'true', `${this.formData.isEnroll}`)
      }
    },
    // 退回
    async rejectFlow() {
      // 获取流程人员
      this.$Spin.show()
      try {
        // 获取taskId,taskId通过读取历史最后一个流程信息获得
        this.operateFlowHistory = []
        let hisRep = await getFlowHistory(this.user.phoneNumber, this.formData.workFlowId)
        this.operateFlowHistory = hisRep
        this.operateFlowTaskId = hisRep[hisRep.length-1].TaskId
        this.selectedPeople = hisRep[hisRep.length-1].FromCreator
        let rep = await getRejectActivityUsers(this.user.phoneNumber, this.operateFlowTaskId)
        this.$Spin.hide()
        this.flowBranch = rep
        if(rep.length > 1) {
          this.$Message.error('该状态下的项目不可退回')
          return
        }
        this.branchVisible = true
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('退回流程获取失败')
      }
    },
    async rejectFlowConfirm() {
      this.$Spin.show()
      try {
        let rep = await rejectFlow(this.user.phoneNumber, { taskId: this.operateFlowTaskId, activityCode: this.flowPeople.ActivityCode, opinion: this.$refs.flowBranch.opinion })
        let next = this.flowBranch[0].ActivityName
        this.formData.reviewPerson = this.selectedPeople  // 操作人员
        switch (true) {
          case next.indexOf('提单') != -1:
            this.formData.project_status = '立项审核退回'
            this.dataUpdate(this.formData).then(() => {
              let reason = this.$refs.flowBranch.opinion
              // 信息通知
              let messageParams = {
                appId: '1005',
                uniqueId: this.formData.principal, // 用户名
                contentJson: {
                  title: '投标管理',
                  subTitle: '立项审核',
                  description: `项目：${this.formData.project_name} 立项不通过，原因为${reason}`,
                  url: 'http://qy.chinapsp.cn:8884?qyLogin#/customerManage/tbgl2'
                }
              }
              sendMessage('wechat', messageParams)
              // 刷新表格
              this.getProjectData(1,{})
            })
            break
          case next.indexOf('投标文件') != -1:
            this.formData.project_status = '等待上传投标文件'
            this.dataUpdate(this.formData).then(() => {
              // 信息通知
              let messageParams = {
                appId: '1005',
                uniqueId: this.formData.principal, // 用户名
                contentJson: {
                  title: '投标管理',
                  subTitle: '文件审核',
                  description: `项目：${this.formData.project_name} 投标文件审核不通过，请修改后重新上传提交`,
                  url: 'http://qy.chinapsp.cn:8884?qyLogin#/customerManage/tbgl2'
                }
              }
              sendMessage('wechat', messageParams)
            })
            break
          case next.indexOf('报名文件') != -1:
            this.formData.project_status = '等待上传报名资料'
            this.dataUpdate(this.formData).then(() => {
              // 信息通知
              let messageParams = {
                appId: '1005',
                uniqueId: this.formData.principal, // 用户名
                contentJson: {
                  title: '投标管理',
                  subTitle: '资料审核',
                  description: `项目：${this.formData.project_name} 报名资料已被退回，请修改后重新上传提交`,
                  url: 'http://qy.chinapsp.cn:8884?qyLogin#/customerManage/tbgl2'
                }
              }
              sendMessage('wechat', messageParams)
            })
            break
          case next.indexOf('终稿') != -1:
            this.formData.project_status = '等待上传投标文件终稿'
            this.dataUpdate(this.formData).then(() => {
              // 信息通知
              let messageParams = {
                appId: '1005',
                uniqueId: this.formData.principal, // 用户名
                contentJson: {
                  title: '投标管理',
                  subTitle: '文件审核',
                  description: `项目：${this.formData.project_name} 投标文件终稿已被退回，请修改后重新上传提交`,
                  url: 'http://qy.chinapsp.cn:8884?qyLogin#/customerManage/tbgl2'
                }
              }
              sendMessage('wechat', messageParams)
            })
        }
        setTimeout(() => {
          this.branchVisible = false 
          this.$Message.success('退回操作成功')
          this.$Spin.hide()
          this.selectedPeople = {}
        }, 1000);
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('退回操作失败')
      }
    }
  }
};
</script>

<style lang="less">
.search-wrapper {
  margin: 0 0 10px 0;
}
.bidding-modal {
  .ivu-modal {
    top: 20px;
    height: 95%;
    .ivu-modal-content {
      height: 100%;
    }
    .ivu-modal-body {
      height: 90%;
      overflow: hidden;
      padding: 0;
    }
  }
}
</style>
